import React, { useEffect, useRef, useState } from "react";
import "../../styles.scss";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useUser } from '../../utils/userContext';

function Sidebar() {
  const location = useLocation();
  const { user } = useUser();
  console.log("user", user?.UserAccessLevel)
  const hasFetchedRef = useRef(false);

  const isActiveRoute = (routes) => {
    if (!Array.isArray(routes)) {
      routes = [routes];
    }

    return routes.some(route => {
      if (route.includes(':')) {
        const baseRoute = route.split(':')[0];
        return location.pathname.startsWith(baseRoute);
      }

      switch (route) {
        case "/Employees":
          return location.pathname.startsWith("/EmployeeDetails") || location.pathname.startsWith("/EmployeeUpdate") ||
            location.pathname === route;
        case "/offboardemployee":
          return location.pathname.startsWith("/assethandover") || location.pathname.startsWith("/settlement") ||
            location.pathname === route;
        case "/onboardemployee":
          return location.pathname.startsWith("/assignasset") || location.pathname.startsWith("/welcomekit") ||
            location.pathname === route;
        case "/Home":
          return location.pathname.startsWith("/Dashboard") ||
            location.pathname === route;
        default:
          return location.pathname === route;
      }
    });
  };

  useEffect(() => {
    // Function to handle mousemove event for rolling up
    const handleRollUp = () => {
      const scrollable = document.getElementById("scrollable");
      if (scrollable) {
        scrollable.scrollTop += 10;
      }
    };

    // Function to handle mousemove event for rolling down
    const handleRollDown = () => {
      const scrollable = document.getElementById("scrollable");
      if (scrollable) {
        scrollable.scrollTop -= 10;
      }
    };

    // Attach event listeners for rolling up and down
    const rollUp = document.getElementById("rollUp");
    const rollDown = document.getElementById("rollDown");

    if (rollUp) {
      rollUp.addEventListener("mousemove", handleRollUp);
    }
    if (rollDown) {
      rollDown.addEventListener("mousemove", handleRollDown);
    }

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      if (rollUp) {
        rollUp.removeEventListener("mousemove", handleRollUp);
      }
      if (rollDown) {
        rollDown.removeEventListener("mousemove", handleRollDown);
      }
    };
  }, []);

  useEffect(() => {
    const sidebarSmall = document.querySelector(
      ".two-sidebar .app-sidebar-small"
    );
    const sidebar = document.querySelector(".two-sidebar .app-sidebar");

    const handleMouseOver = () => {
      if (sidebar) {
        sidebar.classList.add("app-sidebar-hover");
      }
    };

    const handleMouseLeave = () => {
      if (sidebar) {
        sidebar.classList.remove("app-sidebar-hover");
      }
    };

    if (sidebarSmall) {
      sidebarSmall.addEventListener("mouseover", handleMouseOver);
      sidebarSmall.addEventListener("mouseleave", handleMouseLeave);
    }

    // Clean up event listeners
    return () => {
      if (sidebarSmall) {
        sidebarSmall.removeEventListener("mouseover", handleMouseOver);
        sidebarSmall.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);
  const [userAccessLevel, setUserAccessLevel] = useState(user?.UserAccessLevel);
  const [permissions, setPermissions] = useState([]);

  const fetchPermissions = async () => {
    try {
      const path = "/permissionDetails";
      const URL = process.env.REACT_APP_BE_URL + path;
      const storedToken = localStorage.getItem("token");
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      return response.data.permissions;
    } catch (error) {
      console.error('Error fetching permissions:', error);
      return [];
    }
  };

  useEffect(() => {
    // Fetch permissions data
    const fetchPermissionsData = async () => {
      const permissionsData = await fetchPermissions();
      setPermissions(permissionsData);
    };

    if (!hasFetchedRef.current) {
      fetchPermissionsData();
      hasFetchedRef.current = true;
    }
  }, []);

  const hasAccess = (featureName) => {
    const feature = permissions.find(
      (permission) => permission.featureName === featureName
    );
    if (feature && user?.UserAccessLevel) {
      const normalizedAccessLevel = user.UserAccessLevel.replace(/\s+/g, "").toLowerCase();
      for (let key in feature) {
        const normalizedKey = key.replace(/\s+/g, "").toLowerCase();
        if (
          normalizedKey === normalizedAccessLevel &&
          feature[key] === "Yes"
        ) {
          return true;
        }
      }
    }
    return false;
  };

  // Show only Partners for Partner usertype
  console.log("user?.usertype", user);
  if (user?.UserAccessLevel === "Partner") {
    if (location.pathname !== "/partner-dashboard") {
      window.location.href = "/partner-dashboard";
      return null;
    }
    return (
      <div>
        <div className="two-sidebar sidebar-1 sidebar-default">
          <div className="app-sidebar-small">
            <div className="sidebar-top">
              <div className="app-sidebar-small-logo" onClick={() => window.location.href = '/partner-dashboard'}></div>
            </div>
            <div className="sidebar-middle" id="scrollable">
              <div className="sidebar-menu-icon">
                <ul className="nav nav-pills list-inline m-0 p-0" id="icon-pills-tab" role="tablist">
                  <li className="nav-item d-block">
                    <a
                      className="nav-link active"
                      data-toggle="pill"
                      href="#partner-dashboard-pan"
                      role="tab"
                      title="Partner Dashboard"
                      rel="tooltip"
                    >
                      <span>
                        <i className="ri-user-settings-fill"></i>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="app-sidebar">
            <nav className="app-sidebar-menu">
              <div className="tab-content">
                <div
                  className="tab-pane fade active show"
                  id="partner-dashboard-pan"
                  role="tabpanel"
                >
                  <div className="app-sidebar-top">
                    <div className="top-menu-icon">
                      <h5 className="title">Partner Dashboard</h5>
                    </div>
                  </div>
                  <div className="data-scrollbar">
                    <ul id="partner-dashboard" className="app-menu list-inline m-0">
                      <li className="active">
                        <Link to="/partner-dashboard">
                          <span>Dashboard</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }
  if (user?.UserAccessLevel === "Vendor" || user?.UserAccessLevel === "Vendor") {
    // Always call hooks at the top level
    if (
      user?.UserAccessLevel === "Vendor" &&
      window.location.pathname !== "/vendor-invoices" &&
      window.location.pathname !== "/vendor-invoices-dashboard"
    ) {
      window.location.href = "/vendor-invoices";
    }
    // Allow navigation to vendor pages
    return (
      <div>
        <div className="two-sidebar sidebar-1 sidebar-default">
          <div className="app-sidebar-small">
            <div className="sidebar-top">
              <div className="app-sidebar-small-logo" onClick={() => window.location.href = '/vendor-invoices'}></div>
            </div>
            <div className="sidebar-middle" id="scrollable">
              <div className="sidebar-menu-icon">
                <ul className="nav nav-pills list-inline m-0 p-0" id="icon-pills-tab" role="tablist">
                  <li className="nav-item d-block">
                    <a
                      className={`nav-link ${location.pathname === "/vendor-invoices" ? "active" : ""}`}
                      data-toggle="pill"
                      href="#vendor-invoices-pan"
                      role="tab"
                      title="Vendor Invoices"
                      rel="tooltip"
                    >
                      <span>
                        <i className="ri-file-list-3-fill"></i>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item d-block">
                    <a
                      className={`nav-link ${location.pathname === "/vendor-invoices-dashboard" ? "active" : ""}`}
                      data-toggle="pill"
                      href="#vendor-dashboard-pan"
                      role="tab"
                      title="Vendor Dashboard"
                      rel="tooltip"
                    >
                      <span>
                        <i className="ri-dashboard-fill"></i>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="app-sidebar">
            <nav className="app-sidebar-menu">
              <div className="tab-content">
                <div
                  className={`tab-pane fade ${location.pathname === "/vendor-invoices" ? "active show" : ""}`}
                  id="vendor-invoices-pan"
                  role="tabpanel"
                >
                  <div className="app-sidebar-top">
                    <div className="top-menu-icon">
                      <h5 className="title">Vendor Invoices</h5>
                    </div>
                  </div>
                  <div className="data-scrollbar">
                    <ul id="vendor-invoices" className="app-menu list-inline m-0">
                      <li className={location.pathname === "/vendor-invoices" ? "active" : ""}>
                        <Link to="/vendor-invoices">
                          <span>Invoice Management</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${location.pathname === "/vendor-invoices-dashboard" ? "active show" : ""}`}
                  id="vendor-dashboard-pan"
                  role="tabpanel"
                >
                  <div className="app-sidebar-top">
                    <div className="top-menu-icon">
                      <h5 className="title">Vendor Dashboard</h5>
                    </div>
                  </div>
                  <div className="data-scrollbar">
                    <ul id="vendor-dashboard" className="app-menu list-inline m-0">
                      <li className={location.pathname === "/vendor-invoices-dashboard" ? "active" : ""}>
                        <Link to="/vendor-invoices-dashboard">
                          <span>Invoices Dashboard</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div class="two-sidebar sidebar-1 sidebar-default">
        <div class="app-sidebar-small">
          <div class="sidebar-top">
            <div class="app-sidebar-small-logo" onClick={() => window.location.href = '/home'}></div>
          </div>
          <div class="s-up" title="Roll Down" rel="tooltip" id="rollDown">
            <i class="ri-arrow-up-wide-line"></i>
          </div>
          <div class="sidebar-middle" id="scrollable">
            <div class="sidebar-menu-icon">
              <ul
                class="nav nav-pills list-inline m-0 p-0"
                id="icon-pills-tab"
                role="tablist"
              >
                {hasAccess("Home") && (
                  <li class="nav-item d-block">
                    <a
                      className={`nav-link ${isActiveRoute(["/home", "/profile", "/Dashboard", "/holidays", "/announcements", "/master-reports"]) ? "active" : ""
                        }`}
                      data-toggle="pill"
                      href="#home-pan"
                      role="tab"
                      title="Home"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-home-4-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Employee Management") && (
                  <li class="nav-item d-block">
                    <a
                      // class="nav-link"
                      className={`nav-link ${isActiveRoute([
                        "/onboardemployee",
                        "/offboardemployee",
                        "/EmployeeSeparation",
                        "/updatewelcomekit",
                      ])
                        ? "active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#employee-management-pan"
                      role="tab"
                      title="Employee Management"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-user-settings-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Asset Management") && (
                  <li class="nav-item d-block">
                    <a
                      //  className={`nav-link ${isActiveRoute(['/RegisterAsset','/AssetInventory']) ? 'active' : ''}`}
                      className={`nav-link ${isActiveRoute([
                        "/RegisterAsset",
                        "/AssetInventory",
                        "/AssignAssetList",
                        "/AssignedAssetList",
                        "/AssetMasterReport",
                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#asset-management-pan"
                      role="tab"
                      title="Asset Management"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-swap-2-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Self-service") && (
                  <li class="nav-item d-block">
                    <a
                      // class="nav-link"
                      className={`nav-link ${isActiveRoute([
                        "/Payslips",
                        "/PersonalInformation",
                        "/MedicalInsurance",
                        "/AdvanceSalary",
                        "/ExitRequest",
                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#self-service-pan"
                      role="tab"
                      title="Self-service"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-fingerprint-line"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Timesheet") && (
                  <li class="nav-item d-block">
                    <a
                      // class="nav-link"
                      className={`nav-link ${isActiveRoute([
                        "/SubmitTimesheet",
                        "/ViewTimesheet",
                        "/ApproveTimesheet",
                        "/TimesheetReport",
                        "/OnboardProjects",
                        "/AssignProjects"
                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#timesheet-pan"
                      role="tab"
                      title="Timesheet"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-calendar-schedule-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Leave Management") && (
                  <li class="nav-item d-block">
                    <a
                      // class="nav-link"
                      className={`nav-link ${isActiveRoute([
                        "/SubmitLeave",
                        "/LeaveStatus",
                        "/LeaveReport",
                        "/LeaveBalance",
                        "/LeaveApproval"
                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#leave-management-pan"
                      role="tab"
                      title="Leave Management"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-calendar-todo-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Organisation") && (
                  <li class="nav-item d-block">
                    <a
                      className={`nav-link ${isActiveRoute([
                        "/Employees",
                        "/ProfileSearch",
                        "/policies",
                        "/UploadPolicy",
                        "/HrConnect",
                        "/UploadCenter",
                        "/Complaint",
                        "/ComplaintList",
                        "/Permissions",
                        "/SalaryRequests",
                        "/HrList",
                        "/org-chart"
                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#organisation-pan"
                      role="tab"
                      title="Organisation"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-building-2-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Vendor Management") && (
                  <li class="nav-item d-block">
                    <a
                      // class="nav-link"
                      className={`nav-link ${isActiveRoute([
                        "/vendors",
                        "/invoices"
                      ])
                        ? "active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#vendor-management-pan"
                      role="tab"
                      title="Vendor Management"
                      rel="tooltip"
                    >
                      <span>
                        <i className="ri-store-3-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
                {hasAccess("Partner Management") && (
                  <li class="nav-item d-block">
                    <a
                      className={`nav-link ${isActiveRoute([
                        "/partners",
                        "/partnerinvoices"
                      ])
                        ? "active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#partner-management-pan"
                      role="tab"
                      title="Partner Management"
                      rel="tooltip"
                    >
                      <span>
                        <i className="ri-team-fill"></i>
                      </span>
                    </a>
                  </li>
                )}


                {hasAccess("Guest Registration") && (
                  <li class="nav-item d-block">
                    <a
                      className={`nav-link ${isActiveRoute([
                        "/SubmitClaims",
                        "/ClaimStatus",
                        "/ClaimReport",
                        "/GuestList",
                        "/GuestRegistartion",
                        "/SubmitRequest",
                        "/RequestStatus",
                        "/RequestReport",
                        "/ocr",
                        "/Bookticket",
                        "/MyOrders",
                        "/Tickets",
                        "/Bookingrequests"

                      ])
                        ? " active"
                        : ""
                        }`}
                      data-toggle="pill"
                      href="#more-pan"
                      role="tab"
                      title="More"
                      rel="tooltip"
                    >
                      <span>
                        <i class="ri-more-2-fill"></i>
                      </span>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div class="s-down" title="Roll Up" rel="tooltip" id="rollUp">
            <i class="ri-arrow-down-wide-line"></i>
          </div>
          {hasAccess("OverAll Reports") ? (
            <div className="sidebar-bottom">
              <div className="sidebar-menu-icon">
                <a className="btn-bottom" href="/master-reports" title="Reports" rel="tooltip">
                  <span>
                    <i className="ri-pie-chart-fill"></i>
                  </span>
                </a>
              </div>
            </div>
          ) : (
            <div className="sidebar-bottom">
              <div className="sidebar-menu-icon">
                <a className="btn-bottom" href="#" title="Reports" rel="tooltip">
                  <span>
                    <i className="ri-pie-chart-fill"></i>
                  </span>
                </a>
                {/* <i className="ri-pie-chart-fill"></i> */}
              </div>
            </div>
          )}

        </div>

        <div class="app-sidebar">
          <div>
            <nav class="app-sidebar-menu">
              <div class="tab-content">
                <div
                  // class="tab-pane fade active"
                  className={`tab-pane fade ${isActiveRoute(["/home", "/profile", "/Dashboard", "/holidays", "/announcements", "/master-reports"]) ? "active show" : ""
                    }`}
                  id="home-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Home</h5>
                    </div>
                  </div>

                  <div class="data-scrollbar">
                    <ul id="home" class="app-menu list-inline m-0">
                      {hasAccess("Dashboard") && (
                        <li class={`${isActiveRoute("/home") ? "active" : ""}`}>
                          <Link to={"/home"}>
                            <span>Dashboard</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("My Profile") && (
                        <li
                          class={`${isActiveRoute("/profile") ? "active" : ""}`}
                        >
                          <Link to={"/profile"}>
                            <span>Profile</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Holidays") && (
                        <li class={`${isActiveRoute("/holidays") ? "active" : ""}`}>
                          <Link to={"/holidays"}>
                            <span>Upload Holidays</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Announcements") && (
                        <li class={`${isActiveRoute("/announcements") ? "active" : ""}`}>
                          <Link to={"/announcements"}>
                            <span>Announcements</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Settings") && (
                        <li class={`${isActiveRoute("#") ? "active" : ""}`}>
                          <a href="#">
                            <span>Settings</span>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  // class="tab-pane fade"
                  className={`tab-pane fade ${isActiveRoute([
                    "/onboardemployee",
                    "/offboardemployee",
                    "/EmployeeSeparation",
                    "/updatewelcomekit",
                  ])
                    ? "active show"
                    : ""
                    }`}
                  id="employee-management-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Employee Management</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <ul
                      id="employee-management"
                      class="app-menu list-inline m-0"
                    >
                      {hasAccess("Onboard") && (
                        <li
                          class={`${isActiveRoute("/onboardemployee") ? "active" : ""
                            }`}
                        >
                          <Link to="/onboardemployee">
                            <span>Onboard</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Offboard") && (
                        <li
                          class={`${isActiveRoute("/offboardemployee") ? "active" : ""
                            }`}
                        >
                          <Link to={"/offboardemployee"}>
                            <span>Offboard</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Employee Separation") && (
                        <li
                          class={`${isActiveRoute("/EmployeeSeparation") ? "active" : ""
                            }`}
                        >
                          <Link to={"/EmployeeSeparation"}>
                            <span>Separation</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("WelcomeKit") && (
                        <li
                          class={`${isActiveRoute("/updatewelcomekit") ? "active" : ""
                            }`}
                        >
                          <Link to={"/updatewelcomekit"}>
                            <span>Welcome Kit</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/RegisterAsset",
                    "/AssetInventory",
                    "/AssignAssetList",
                    "/AssignedAssetList",
                    "/AssetMasterReport",
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="asset-management-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Asset Management</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <ul id="asset-management" class="app-menu list-inline m-0">
                      {hasAccess("Register Asset") && (
                        <li
                          class={`${isActiveRoute("/RegisterAsset") ? "active" : ""
                            }`}
                        >
                          <Link to={"/RegisterAsset"}>
                            <span>Register</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Asset Inventory") && (
                        <li
                          class={`${isActiveRoute("/AssetInventory") ? "active" : ""
                            }`}
                        >
                          <Link to={"/AssetInventory"}>
                            <span>Inventory</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Assign Asset") && (
                        <li
                          class={`${isActiveRoute("/AssignAssetList") ? "active" : ""
                            }`}
                        >
                          <Link to={"/AssignAssetList"}>
                            <span>Assign</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Assigned Assets") && (
                        <li
                          class={`${isActiveRoute("/AssignedAssetList") ? "active" : ""
                            }`}
                        >
                          <Link to={"/AssignedAssetList"}>
                            <span>Assigned List</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Master Report") && (
                        <li
                          class={`${isActiveRoute("/AssetMasterReport") ? "active" : ""
                            }`}
                        >
                          <Link to={"/AssetMasterReport"}>
                            <span>Report</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/Payslips",
                    "/PersonalInformation",
                    "/MedicalInsurance",
                    "/AdvanceSalary",
                    "/ExitRequest",
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="self-service-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Self-service</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <div class="more-app-links">
                      {hasAccess("Payslips") && (
                        <div
                          className={`card ${isActiveRoute("/Payslips")
                            ? "more-app-links active"
                            : ""
                            }`}
                        >
                          <div class="card-body">
                            <div>
                              <Link
                                to={"/Payslips"}
                                className={`stretched-link ${isActiveRoute("/Payslips") ? "active" : ""
                                  }`}
                              >
                                <span>
                                  <i class="ri-file-list-3-fill"></i>
                                </span>
                                <span>Payslips</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                      {hasAccess("Personal Information") && (
                        <div className={`card ${isActiveRoute('/PersonalInformation') ? 'more-app-links active' : ''}`}>
                          <div className="card-body">
                            <div>
                              <Link to={'/PersonalInformation'} className={`stretched-link ${isActiveRoute('/PersonalInformation') ? 'active' : ''}`}>
                                <span><i className="ri-contacts-book-3-line"></i></span>
                                <span>Personal Information</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                      {hasAccess("Medical Insurance") && (
                        <div className={`card ${isActiveRoute('/MedicalInsurance') ? 'more-app-links active' : ''}`}>
                          <div className="card-body">
                            <Link to={'/MedicalInsurance'} className={`stretched-link ${isActiveRoute('/MedicalInsurance') ? 'active' : ''}`}>
                              <span><i className="ri-shield-user-line"></i></span>
                              <span>Medical Insurance</span>
                            </Link>
                          </div>
                        </div>
                      )}
                      {hasAccess("Advance Salary") && (
                        <div className={`card ${isActiveRoute('/AdvanceSalary') ? 'more-app-links active' : ''}`}>
                          <div className="card-body">
                            <Link to={'/AdvanceSalary'} className={`stretched-link ${isActiveRoute('/AdvanceSalary') ? 'active' : ''}`}>
                              <span><i className="ri-cash-line"></i></span>
                              <span>Advance Salary</span>
                            </Link>
                          </div>
                        </div>
                      )}
                      {hasAccess("Exit Request") && (
                        <div className={`card ${isActiveRoute('/ExitRequest') ? 'more-app-links active' : ''}`}>
                          <div className="card-body">
                            <Link to={'/ExitRequest'} className={`stretched-link ${isActiveRoute('/ExitRequest') ? 'active' : ''}`}>
                              <span><i className="ri-walk-fill"></i></span>
                              <span>Exit Request</span>
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/SubmitTimesheet",
                    "/ViewTimesheet",
                    "/ApproveTimesheet",
                    "/TimesheetReport",
                    "/OnboardProjects",
                    "/AssignProjects"
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="timesheet-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Timesheet & PMO</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <div class="more-app-links">
                      <ul class="list-inline second-level" id="timesheetMenus">
                        <li>
                          <a
                            href="#timesheet-menus"
                            class="collapse"
                            data-toggle="collapse"
                          >
                            <span>Timesheet</span>
                          </a>
                          <ul
                            id="timesheet-menus"
                            class="second-level-submenu collapse show"
                            data-parent="#timesheetMenus"
                          >
                            {hasAccess("Submit Timesheet") && (
                              <li
                                class={`${isActiveRoute("/SubmitTimesheet")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/SubmitTimesheet"}>
                                  <span>Submit</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("View Timesheet") && (
                              <li
                                class={`${isActiveRoute("/ViewTimesheet") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/ViewTimesheet"}>
                                  <span>View</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Approve Timesheet") && (
                              <li
                                class={`${isActiveRoute("/ApproveTimesheet")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/ApproveTimesheet"}>
                                  <span>Approve</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Timesheet Report") && (
                              <li
                                class={`${isActiveRoute("/TimesheetReport")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/TimesheetReport"}>
                                  <span>Report</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                        <li>
                          <a
                            href="#pmo-menus"
                            class="collapsed"
                            data-toggle="collapse"
                          >
                            <span>Project Control Center</span>
                          </a>
                          <ul
                            id="pmo-menus"
                            class="second-level-submenu collapse"
                            data-parent="#timesheetMenus"
                          >
                            {hasAccess("Projects Dashboard") && (
                              <li
                                class={`${isActiveRoute("/OnboardProjects")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/OnboardProjects"}>
                                  <span>Projects</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Assign Project") && (
                              <li
                                class={`${isActiveRoute("/AssignProjects") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/AssignProjects"}>
                                  <span>Assign</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  // class="tab-pane fade"
                  className={`tab-pane fade ${isActiveRoute([
                    "/SubmitLeave",
                    "/LeaveStatus",
                    "/LeaveReport",
                    "/LeaveBalance",
                    "/LeaveApproval"
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="leave-management-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Leave Management</h5>
                    </div>
                  </div>

                  <div class="data-scrollbar">
                    <ul id="leave-management" class="app-menu list-inline m-0">
                      {hasAccess("Submit Leave") && (
                        <li
                          class={`${isActiveRoute("/SubmitLeave") ? "active" : ""
                            }`}
                        >
                          <Link to={"/SubmitLeave"}>
                            <span>Submit</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Leave Status") && (
                        <li
                          class={`${isActiveRoute("/LeaveStatus") ? "active" : ""
                            }`}
                        >
                          <Link to={"/LeaveStatus"}>
                            <span>Status</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Leave Approval") && (
                        <li
                          class={`${isActiveRoute("/LeaveApproval") ? "active" : ""
                            }`}
                        >
                          <Link to={"/LeaveApproval"}>
                            <span>Approval</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Leave Balance") && (
                        <li
                          class={`${isActiveRoute("/LeaveBalance") ? "active" : ""
                            }`}
                        >
                          <Link to={"/LeaveBalance"}>
                            <span>Balance</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Leave Report") && (
                        <li
                          class={`${isActiveRoute("/LeaveReport") ? "active" : ""
                            }`}
                        >
                          <Link to={"/LeaveReport"}>
                            <span>Report</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/Employees",
                    "/ProfileSearch",
                    "/policies",
                    "/UploadPolicy",
                    "/HrConnect",
                    "/UploadCenter",
                    "/Complaint",
                    "/ComplaintList",
                    "/Permissions",
                    "/SalaryRequests",
                    "/HrList",
                    "/org-chart",
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="organisation-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Organisation</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <ul id="organisation" class="app-menu list-inline m-0">
                      {hasAccess("Employees") && (
                        <li
                          class={`${isActiveRoute("/Employees") ? "active" : ""}`}
                        >
                          <Link to={"/Employees"}>
                            <span>Employees</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Profile Search") && (
                        <li
                          class={`${isActiveRoute("/ProfileSearch") ? "active" : ""
                            }`}
                        >
                          <Link to={"/ProfileSearch"}>
                            <span>Profile Search</span>
                          </Link>
                        </li>
                      )}
                      <li>
                        <a
                          href="#org-policies"
                          class="first-level-submenu collapsed"
                          data-toggle="collapse"
                        >
                          <span>Policies</span>
                        </a>
                        <ul
                          id="org-policies"
                          class="second-level-submenu collapse"
                          data-parent="#organisation"
                        >
                          {hasAccess("Upload Policies") && (
                            <li
                              class={`${isActiveRoute("/UploadPolicy") ? "active" : ""
                                }`}
                            >
                              <Link to={"/UploadPolicy"} >
                                <span>Upload</span>
                              </Link>
                            </li>
                          )}
                          {hasAccess("View Policies") && (
                            <li
                              class={`${isActiveRoute("/policies") ? "active" : ""
                                }`}
                            >
                              <Link to={"/policies"}>
                                <span>Policies</span>
                              </Link>
                            </li>
                          )}
                          
                        </ul>
                      </li>
                      <li>
                        <a
                          href="#org-hr"
                          class="first-level-submenu collapsed"
                          data-toggle="collapse"
                        >
                          <span>HR</span>
                        </a>
                        <ul
                          id="org-hr"
                          class="second-level-submenu collapse"
                          data-parent="#organisation"
                        >
                          {hasAccess("HR Connect") && (
                            <li
                              class={`${isActiveRoute("/HrConnect") ? "active" : ""
                                }`}
                            >
                              <Link to={"/HrConnect"} >
                                <span>Connect</span>
                              </Link>
                            </li>
                          )}
                          {hasAccess("HR List") && (
                            <li
                              class={`${isActiveRoute("/HrList") ? "active" : ""}`}
                            >
                              <Link to={"/HrList"}>
                                <span>Report</span>
                              </Link>
                            </li>
                          )}
                          
                        </ul>
                      </li>
                      <li>
                        <a
                          href="#org-complaint"
                          class="first-level-submenu collapsed"
                          data-toggle="collapse"
                        >
                          <span>Complaint<br></br> and Feedback</span>
                        </a>
                        <ul
                          id="org-complaint"
                          class="second-level-submenu collapse"
                          data-parent="#organisation"
                        >
                          
                          {hasAccess("Submit Complaint and Feedback") && (
                            <li
                              class={`${isActiveRoute("/Complaint") ? "active" : ""
                                }`}
                            >
                              <Link to={"/Complaint"} >
                                <span>Submit</span>
                              </Link>
                            </li>
                          )}
                          {hasAccess("Complaint and Feedback List") && (
                            <li
                              class={`${isActiveRoute("/ComplaintList") ? "active" : ""}`}
                            >
                              <Link to={"/ComplaintList"}>
                                <span>Report</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                      {hasAccess("Upload Center") && (
                        <li
                          class={`${isActiveRoute("/UploadCenter") ? "active" : ""
                            }`}
                        >
                          <Link to={"/UploadCenter"}>
                            <span>Upload Center</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Organisation Chart") && (
                        <li
                          class={`${isActiveRoute("/org-chart") ? "active" : ""
                            }`}
                        >
                          <Link to={"/org-chart"}>
                            <span>Organisation Chart</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Permissions") && (
                        <li>
                          <Link to={"/Permissions"}>
                            <span>Permissions</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Advance Salary Requests") && (
                        <li>
                          <Link to={"/SalaryRequests"}>
                            <span>Advance Salary Requests</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/vendors",
                    "/invoices"
                  ])
                    ? "active show"
                    : ""
                    }`}
                  id="vendor-management-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Vendor Management</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <ul id="vendor-management" class="app-menu list-inline m-0">
                      {hasAccess("Vendor") && (
                        <li
                          class={`${isActiveRoute("/vendors") ? "active" : ""}`}
                        >
                          <Link to={"/vendors"}>
                            <span>Vendors</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Invoices") && (
                        <li
                          class={`${isActiveRoute("/invoices") ? "active" : ""}`}
                        >
                          <Link to={"/invoices"}>
                            <span>Invoices</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/partners",
                    "/partnerinvoices"
                  ])
                    ? "active show"
                    : ""
                    }`}
                  id="partner-management-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">Partner Management</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <ul id="partner-management" class="app-menu list-inline m-0">
                      {hasAccess("Partner") && (
                        <li class={`${isActiveRoute("/partners") ? "active" : ""}`}>
                          <Link to={"/partners"}>
                            <span>Partners</span>
                          </Link>
                        </li>
                      )}
                      {hasAccess("Partnerinvoices") && (
                        <li class={`${isActiveRoute("/partnerinvoices") ? "active" : ""}`}>
                          <Link to={"/partnerinvoices"}>
                            <span>Partner Invoices</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>


                <div
                  className={`tab-pane fade ${isActiveRoute([
                    "/SubmitClaims",
                    "/ClaimStatus",
                    "/ClaimReport",
                    "/GuestList",
                    "/GuestRegistartion",
                    "/SubmitRequest",
                    "/RequestStatus",
                    "/RequestReport",
                    "/ocr",
                    "/Bookticket",
                    "/My-Orders",
                    "/Tickets",
                    "/Bookingrequests"
                  ])
                    ? " active show"
                    : ""
                    }`}
                  id="more-pan"
                  role="tabpanel"
                >
                  <div class="app-sidebar-top">
                    <div class="top-menu-icon">
                      <h5 class="title">More</h5>
                    </div>
                  </div>
                  <div class="data-scrollbar">
                    <div class="more-app-links">
                      <ul class="list-inline second-level" id="moreMenus">
                        <li>
                          <a
                            href="#claims-menu"
                            class="collapsed"
                            data-toggle="collapse"
                          >
                            <span>Expense Management</span>
                          </a>
                          <ul
                            id="claims-menu"
                            class="second-level-submenu collapse"
                            data-parent="#moreMenus"
                          >
                            {hasAccess("Submit Claims") && (
                              <li
                                class={`${isActiveRoute("/SubmitClaims") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/SubmitClaims"}>
                                  <span>Submit</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Claims Status") && (
                              <li
                                class={`${isActiveRoute("/ClaimStatus") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/ClaimStatus"}>
                                  <span>Status</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Claims Report") && (
                              <li
                                class={`${isActiveRoute("/ClaimReport") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/ClaimReport"} >
                                  <span>Report</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                        <li>
                          <a
                            href="#guest-registration-menu"
                            class="collapsed"
                            data-toggle="collapse"
                          >
                            <span>Guest Registration</span>
                          </a>
                          <ul
                            id="guest-registration-menu"
                            class="second-level-submenu collapse"
                            data-parent="#moreMenus"
                          >
                            {hasAccess("Register Guest") && (
                              <li
                                class={`${isActiveRoute("/GuestRegistartion")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/GuestRegistartion"}>
                                  <span>Register</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("View Guests") && (
                              <li
                                class={`${isActiveRoute("/GuestList") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/GuestList"}>
                                  <span>View</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                        <li>
                          <a
                            href="#support-request-menu"
                            class="collapsed"
                            data-toggle="collapse"
                          >
                            <span>Support & Request</span>
                          </a>
                          <ul
                            id="support-request-menu"
                            class="second-level-submenu collapse"
                            data-parent="#moreMenus"
                          >
                            {hasAccess("Submit Request") && (
                              <li
                                class={`${isActiveRoute("/SubmitRequest") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/SubmitRequest"}>
                                  <span>Submit</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Request Status") && (
                              <li
                                class={`${isActiveRoute("/RequestStatus") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/RequestStatus"}>
                                  <span>Status</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Request Report") && (
                              <li
                                class={`${isActiveRoute("/RequestReport") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/RequestReport"} >
                                  <span>Report</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>

                        <li>
                          <a
                            href="#travel-desk-menu"
                            class="collapsed"
                            data-toggle="collapse"
                          >
                            <span>Travel Desk</span>
                          </a>
                          <ul
                            id="travel-desk-menu"
                            class="second-level-submenu collapse"
                            data-parent="#moreMenus"
                          >
                            {hasAccess("Bookticket") && (
                              <li
                                class={`${isActiveRoute("/Bookticket")
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <Link to={"/Bookticket"}>
                                  <span>Book Ticket</span>
                                </Link>

                              </li>
                            )}
                            {/* {hasAccess("My Orders") && (
                              <li
                                class={`${isActiveRoute("/My-Orders") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/My-Orders"}>
                                  <span>My Orders</span>
                                </Link>
                              </li>
                            )} */}
                            {hasAccess("Booking Requests") && (
                              <li
                                class={`${isActiveRoute("/Booking Requests") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/Bookingrequests"}>
                                  <span> Booking Requests</span>
                                </Link>
                              </li>
                            )}
                            {hasAccess("Tickets") && (
                              <li
                                class={`${isActiveRoute("/Tickets") ? "active" : ""
                                  }`}
                              >
                                <Link to={"/Tickets"}>
                                  <span>Tickets</span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      </ul>
                      {/* <Link to={"/ocr"} className="no-dropdown">
                        <span>OCR AI</span>
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;